import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getIconImageUrlWithDefault, isCustomIcon } from '../../../../services/Badge';
import styles from './style.m.less';

const propTypes = {
    badge: PropTypes.object,
    size: PropTypes.string,
    ratio: PropTypes.number,
    className: PropTypes.string,
};

const CustomBadge = ({ image, altText, sizeStyle, className }) => (
    <img src={image} style={sizeStyle} alt={altText} className={classNames(styles.customBadgeImage, className)} />
);

const setSizeStyle = size => ({
    width: size,
    height: size,
});

export default function Badge({ baseUrl = '', badge, size = 'auto', className }) {
    const badgeUrl = baseUrl + getIconImageUrlWithDefault(badge?.icon);
    const sizeStyle = setSizeStyle(size);
    const altText = 'Badge: ' + badge?.name;

    if (badge && isCustomIcon(badge.icon)) {
        return <CustomBadge sizeStyle={sizeStyle} altText={altText} image={badgeUrl} className={className} />;
    } else {
        return (
            <img style={sizeStyle} src={badgeUrl} alt={altText} className={classNames(styles.badgeImage, className)} />
        );
    }
}

export function StandaloneCustomBadge({ image, size }) {
    return (
        <div style={setSizeStyle(size)}>
            <CustomBadge image={image} />
        </div>
    );
}

Badge.propTypes = propTypes;
